import common from './common';
import linkTypes from './link-types';
import defaultConfig from './default-config';

export default {
  common,
  linkTypes,
  defaultConfig,
};
